import classNames from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox, { SIZES } from 'components/Checkbox';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Options = ({ filterIdentifier, options, onFilterOptionSelect }) => (
  <ul className="CollectionFilterSelector__options">
    {map(options, ({ option, value }) => {
      return (
        <li className="CollectionFilterSelector__listItem" key={option}>
          <Checkbox
            className={classNames('CollectionFilterSelector__checkbox')}
            ariaLabel={I18n.localize(
              `productAttributes.${filterIdentifier}.options.${option}.label`
            )}
            size={SIZES.SMALL}
            checked={value}
            onClick={() => onFilterOptionSelect({ option, value: !value })}
            onChange={() => {}}
          >
            {I18n.localize(`productAttributes.${filterIdentifier}.options.${option}.label`)}
          </Checkbox>
        </li>
      );
    })}

    <style jsx global>
      {`
        .CollectionFilterSelector__checkbox {
          margin-bottom: ${Theme.get('spacing') * 2}px;
        }

        .CollectionFilterSelector__checkbox.Checkbox .Checkbox__input:checked ~ .Checkbox__label {
          font-weight: ${Theme.get('font-weight-bold')};
        }

        .CollectionFilterSelector__checkbox .Checkbox__label {
          margin-left: ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
  </ul>
);

Options.propTypes = {
  filterIdentifier: PropTypes.string.isRequired,
  onFilterOptionSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Options;
